import HelperClass from "../../CustomHook/HelperClass";

export default function DcAvailavilityReport({ loading, get_data, nextPage,request }){
    console.log(request)
    return (
        <>
        <div className="ms-1 me-1" id="dc_availavility_history">
                <div className="table-responsive bg-white">
                    <table width="100%" border={1} cellPadding={0} cellSpacing={0} className="table table-bordered mt-2 text-center">
                        <thead className="text-center">
                            <tr>
                                <th height={20} colSpan={20} align="center" valign="center" className="col" style={{ fontSize: '18px', fontWeight: 'bold' }}> DC Availability Report
                                </th>
                            </tr>
                            <tr>
                                <th height={20} colSpan={20} align="center" valign="center" className="col" style={{ fontSize: '13px', fontWeight: 'bold' }}> Date: {request?.duration_type==1?request?.start_date:`${request?.start_date} To ${request?.end_date}`}
                                </th>
                            </tr>
                            <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            

                                    {!loading && get_data?.tanents?.map((row, index) => (
                                    <th colspan="4" align="center" valign="center" class="col">Tenant {index+1}</th>
                                    ))}
                             
                            </tr>
                            <tr>
            <th align="center" valign="center" class="col1" >{HelperClass().CUSTOMER_SITE} Site ID</th>

            <th align="center" valign="center" class="col1" >Site ID</th>
            <th align="center" valign="center" class="col1" >Site Name</th>
            <th align="center" valign="center" class="col1" >Cluster</th>
            <th align="center" valign="center" class="col1" >Zone</th>
            <th align="center" valign="center" class="col1" >Date</th>
            
            {!loading && get_data?.tanents?.map((row, index) => (
                                  <>
                                   <th align="center" valign="center" class="col1" >Tenant Name</th>
                <th align="center" valign="center" class="col1" >AC Availability(%)</th>
                <th align="center" valign="center" class="col1" >AC Unavailability(%)</th>
                <th align="center" valign="center" class="col1" >DC Availability(%)</th>
                                  </>
                                    ))}
                                
            </tr>
                        </thead>

                        <tbody>
                        {!loading && get_data?.data?.length>0 && get_data?.data?.map((site, index) => (
                            <tr>
                                <td>{site.easi_site_id}</td>
                                <td>{site.site_id}</td>
                                <td>{site.site_name}</td>
                                <td>{site.cluster_name}</td>
                                <td>{site.zone_name}</td>
                                <td><p className="p-0 m-0" style={{width:'100px'}}>{site.date}</p></td>
                                
                                {!loading && get_data?.tanents?.map((tent, tind) => (
                                  <>
                                   <td align="center" valign="center" class="col1" >{site?.tenant_kwh[tind]?.tenant_name}</td>
                                    <td align="center" valign="center" class="col1" >{site?.tenant_kwh[tind]?.ac_avil}</td>
                                    <td align="center" valign="center" class="col1" >{site?.tenant_kwh[tind]?.ac_avil>=0?(Number(100)-site?.tenant_kwh[tind]?.ac_avil).toFixed(2):''}</td>
                                    <td align="center" valign="center" class="col1" >{site?.tenant_kwh[tind]?.dc_avil}</td>
                                  </>
                                    ))}


                            </tr>
                             ))}
                        </tbody>
                    </table>
                </div>
                {get_data?.has_page ?
                        <div class="float-md-end mb-1 mt-1">
                            <div class="btn-group ">
                                {get_data?.first_page ?
                                    <a class="btn btn-primary btn-sm" style={{ cursor: 'no-drop' }}>Prev</a>
                                    :
                                    <a class="btn btn-primary btn-sm " onClick={() => nextPage(get_data?.prv_page_url)}>Prev</a>
                                }

                                {get_data?.has_more_page ?
                                    <a class="btn btn-info btn-sm " onClick={() => nextPage(get_data?.next_page_url)}>Next</a>
                                    :
                                    <a class="btn btn-info btn-sm " style={{ cursor: 'no-drop' }}>Next</a>

                                }
                            </div>
                        </div> : ''
                    }
            </div>
        </>
    )
}